import React, { useRef, useState, useEffect } from "react"
import ReactFullpage from "@fullpage/react-fullpage"
import tw, { styled } from "twin.macro"
import { Helmet } from "react-helmet"

// Utils
import { SlideInfo } from "../slides"

// Components
import BottomBar from "./bottomBar"
import EnrolSlide from "../slides/enrolSlide"
import FeaturesSlide from "../slides/featuresSlide"
import HeaderVideo from "./headerVideo"
import LearnSlide from "../slides/learnSlide"
import LogoSlide from "../slides/logoSlide"
import SEO from "../components/seo"
import TimeSlide from "../slides/timeSlide"
import TopBar from "./topBar"
import { RESPONSIVE_HEIGHT } from "../utils/constants"

const metaDescription = "Start a rewarding career in the automotive industry. Our MITO Micro Introduction to Automotive Engineering will give you a solid knowledge foundation to build on in the future. Enrol now for free!"

const slides: SlideInfo[] = [
  {
    component: LogoSlide,
    anchor: "#intro",
    seo: { title: "Boost your CV for FREE" },
  },
  {
    component: FeaturesSlide,
    anchor: "#introduction",
    seo: { title: "Introduction to Automotive Engineering" },
  },
  {
    component: TimeSlide,
    anchor: "#howfast",
    seo: { title: "How fast can I get there?" },
  },
  {
    component: LearnSlide,
    anchor: "#learn",
    seo: { title: "What will I learn?" },
  },
  {
    component: EnrolSlide,
    anchor: "#enrol",
    seo: { title: "️Enrol now" },
  },
]

const SlidesContainer: React.FC = () => {
  // Keep isClient == true when it's the client rendering and not the server
  const [isClient, setClient] = useState(false)
  useEffect(() => {
    setClient(true)
    // Move to the slide in the hash.. for some reason this isn't working
    // using the built in support for slide links...
    const slide = window.location.hash
    if (slide) {
      reactFullpage.current?.fullpageApi.moveTo(slide)
    }
  }, [])

  const [slideIndex, setSlideIndex] = useState<number>(0)
  const [hideEnrolButton, setHideEnrolButton] = useState<boolean>(false)
  const reactFullpage: React.RefObject<ReactFullpage> = useRef<ReactFullpage>(
    null
  )

  return (
    <SlidesWrapper>
      <SEO {...slides[slideIndex].seo} description={metaDescription} />
      <Helmet>
        <link rel="stylesheet" href="https://use.typekit.net/imk8sgg.css" />
      </Helmet>

      <TopBar
        hideEnrolButton={hideEnrolButton}
        enrolButtonClicked={() => {
          reactFullpage.current?.fullpageApi.moveTo(5)
        }}
      />

      <HeaderVideo overlay={slideIndex != 0} />

      <ReactFullpage
        ref={reactFullpage}
        scrollingSpeed={1000} /* Options here */
        licenseKey="1B8D94EF-53504EE2-97F80D91-B1AE13D3"
        scrollOverflow
        navigation
        autoScrolling
        recordHistory
        anchors={slides.map(s => s.anchor)}
        // responsiveHeight={RESPONSIVE_HEIGHT}
        onLeave={(origin, destination, direction) => {
          setSlideIndex(destination.index)
          setHideEnrolButton(destination.index == 4)
        }}
        render={({ fullpageApi }) => {
          return (
            <div>
              <ReactFullpage.Wrapper>
                {slides.map((slide, idx) => (
                  <slide.component
                    key={idx}
                    isClient={isClient}
                    nextButtonClicked={() => fullpageApi.moveSectionDown()}
                    slideVisible={slideIndex == idx}
                  />
                ))}
              </ReactFullpage.Wrapper>
            </div>
          )
        }}
      />

      <BottomBar
        hideEnrolButton={hideEnrolButton}
        enrolButtonClicked={() => {
          reactFullpage.current?.fullpageApi.moveTo(5)
        }}
      />
    </SlidesWrapper>
  )
}

const SlidesWrapper = styled.div`
  ${tw`text-white min-h-screen`}
`
export default SlidesContainer
